module.exports = __webpack_public_path__ + "img/ai-interactive.ca3ab507.png";